import { useEffect, useState } from "react";
import { useParams, useNavigate, Link as RouterLink } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import axios from "axios";
import Loader from "../components/Loader";
import { authData } from "../components/GetAuth";
import { TextField, Button, Snackbar, Alert } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { usePlacesWidget } from "react-google-autocomplete";

const DriverAddressEdit = () => {
  const bookingId = useParams();
  const navigate = useNavigate();
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      phone: "",
      address: "",
      post_code: "",
    },
  });

  const { ref: placeRef1 } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("address", place.formatted_address);
      setValue("latitude", place.geometry.location.lat());
      setValue("longitude", place.geometry.location.lng());

      place.address_components.forEach((item) => {
        if (item.types.indexOf("postal_code") > -1) {
          setValue("post_code", item.long_name);
        }
      });
    },
    options: {
      types: ["address"],
    },
  });

  useEffect(() => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/driver/address-details/" + bookingId?.id, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        let editData = response.data.data;

        setValue("name", editData?.name);
        setValue("phone", editData?.phone);
        setValue("address", editData?.address);
        setValue("post_code", editData?.post_code);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }, [API_TOKEN, bookingId, setValue]);

  const onSubmit = (data) => {
    if (bookingId?.id) {
      axios.post(process.env.REACT_APP_API_URL + "v1/driver/address-details/" + bookingId?.id, data, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setTimeout(() => {
            navigate("/driver/today-request-list");
          }, 2000);
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  return (<>
    <div className={`${styles.MainDiv}`}>
      <Loader open={loading} setOpen={setLoading.bind(this)} />
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Request Details</p>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className={`${styles.StepOneForm}`}>
          <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.StepOneFormRow}`}>
              <div className={`${styles.StepOneFormBig}`}>
                <div>
                  <div className={`FormFullGroup`}>
                    <Controller
                      control={control}
                      {...register("name", { required: "This field is Required" })}
                      render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
                    />
                    {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
                  </div>
                </div>

                <div>
                  <div className={`FormFullGroup`}>
                    <Controller
                      control={control}
                      {...register("phone", { required: "This field is Required" })}
                      render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
                    />
                    {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
                  </div>
                </div>

                <div className={`${styles.FormRowHSFull}`}>
                  <div className={`${styles.FormField}`}>
                    <div className={`FormFullGroup`}>
                      <Controller
                        control={control}
                        {...register("post_code", { required: "This field is Required" })}
                        render={({ field }) => (<TextField {...field} label="Post Code*" variant="outlined" />)}
                      />
                      {errors.post_code && (<span className={`ErrorM`}>{errors?.post_code?.message}</span>)}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.StepOneFormSmall2}`}>
                <div className={`FormFullGroup`}>
                  <Controller
                    control={control}
                    {...register("address", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" inputRef={placeRef1} placeholder="" />)}
                  />
                  {errors?.address && (<p className={`${styles.ErrorM}`}>{errors?.address?.message}</p>)}
                </div>
              </div>

              <div className={`${styles.StepBUSec}`}>
                <RouterLink as={Button} to={`/driver/address-details/${bookingId?.id}`} className={`CancelBU`}>Cancel</RouterLink>
                <Button className={`SubmitBU`} type="submit">Save</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default DriverAddressEdit;